import React, { useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

import { getEvaluation } from '../api';


const EvaluationContext = React.createContext(null);


const utoast = (message, options) => {
  const toastId = 'evaluation-context';
  if (message === null) {
    toast.dismiss(toastId)
    return;
  }
  if (!toast.isActive(toastId)) {
    toast(message, {toastId, ...options});
  } else {
    toast.update(toastId, {
      render: message,
      ...options
    });
  }
}


const EvaluationContextProvider = ({ children }) => {
  const params = useParams();
  const [profile, setProfile] = useState(null);
  const [applications, setApplications] = useState(null);

  const fetchEvaluation = useCallback(async () => {
    utoast('Loading your assessments...', {
        isLoading: true,
        closeButton: false,
        autoClose: false,
    });
    try {
      const response = await getEvaluation(params.profile);
      setProfile(response.profile);
      setApplications(response.applications);
      utoast(null);
    } catch (error) {
      utoast('Error loading your assessments. Please contact the person who provided this.', {
        type: 'error',
        isLoading: false,
        autoClose: 5000,
        closeButton: false,
      });
      setProfile(null);
      setApplications(null);
      console.log(error);
    }
  }, [params]);

  useEffect(() => {
      fetchEvaluation();
      return () => {};
    }, [fetchEvaluation],
  );

  const value = useMemo(() => ({
    profile,
    applications,
    fetchEvaluation,
  }), [profile, applications, fetchEvaluation]);


  return (
    <EvaluationContext.Provider value={value}>
      {children}
    </EvaluationContext.Provider>
  );
};


const EvaluationContextConsumer = EvaluationContext.Consumer;


const useEvaluation = () => {
  return useContext(EvaluationContext);
};


export { useEvaluation, EvaluationContext, EvaluationContextProvider, EvaluationContextConsumer };
export default useEvaluation;
